import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonMenuButton,
} from '@ionic/react';

const DepreciationView: React.FC = () => {
  return (
    <IonPage className='pushDown'>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Depreciation View</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {/* TODO: Add depreciation report/view */}
      </IonContent>
    </IonPage>
  );
};

export default DepreciationView;

